import React from "react";
import {SaveOutlined} from "@mui/icons-material";
import {useFormSaveState} from "./FormSaveContext";
import "./formSave.css";

const FormSaveBar = () => {
    const {dirtyCount, saving, saveAll, resetAll} = useFormSaveState();

    if (!dirtyCount) {
        return null;
    }

    return (
        <div className="form-save-bar" role="region" aria-label="Сохранение изменений">
            <div className="form-save-bar__info">
                <span className="form-save-bar__dot" aria-hidden="true"/>
                <span>
                    Несохранённых изменений: <b>{dirtyCount}</b>
                </span>
                <span className="form-save-bar__hint">Ctrl+S — сохранить</span>
            </div>
            <div className="form-save-bar__actions">
                <button
                    type="button"
                    className="btn btn-ghost"
                    onClick={resetAll}
                    disabled={saving}
                >
                    Отменить
                </button>
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={saveAll}
                    disabled={saving}
                >
                    <SaveOutlined fontSize="small"/>
                    {saving ? "Сохраняем…" : "Сохранить"}
                </button>
            </div>
        </div>
    );
};

export default FormSaveBar;
